export default __webpack_public_path__ + "static/media/Harry's Wand - Img - Wip 2_00.f1f1aa41.jpg";